import React, { Component } from 'react';

import BoardInfoMod from './BoardInfoMod';
import BoardInfoDel from './BoardInfoDel';

class BoardInfoItem extends Component {
    getBoardTypeName = (boardTypeCode) => {
        return this.props.boardTypeCodes.map((code, i) => {
            return (code.code === boardTypeCode) ? code.name : "";
        });
    }

    render() {
        return (
            <tr>
                <td className="text-align-center">{this.props.boardInfo.boardName}</td>
                <td className="text-align-center">{this.getBoardTypeName(this.props.boardInfo.boardTypeCode)}</td>
                <td className="table-body-center">
                    <div className="component-align-center">
                        <BoardInfoMod stateRefresh={this.props.stateRefresh} boardInfo={this.props.boardInfo} gradeList={this.props.gradeList} boardTypeCodes={this.props.boardTypeCodes}/>
                        <BoardInfoDel stateRefresh={this.props.stateRefresh} boardInfo={this.props.boardInfo}/>
                    </div>
                </td>
            </tr>
        )
    }
}

export default BoardInfoItem;